import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import shareIcon from '../../assets/share.svg'
import closeIcon from '../../assets/close.svg'
import facebookIcon from '../../assets/facebook.svg'
import twitterIcon from '../../assets/twitter.svg'
import emailIcon from '../../assets/email.svg'
import smsIcon from '../../assets/sms.svg'


export default class ShareButton extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isEnabled: false
    }
  }

  componentDidMount () {
    this.props.setShareButtonsVisible(0)
  }

  handleMainButtonClick = () => {
    if (this.state.isEnabled) {
      this.props.setShareButtonsVisible(0)
    } else {
      this.props.setShareButtonsVisible(1)
    }
    this.setState({ isEnabled: !this.state.isEnabled })
  }

  goToUrl (url) {
    if (url) {
      window.location.href = url
    }
  }

  render () {
    const { facebook, twitter, email, phone, shareTitle, shareSubtitle } = this.props
    return (
      <CSSTransitionGroup
        transitionName='bo_share'
        transitionEnterTimeout={750}
        transitionLeaveTimeout={750}
      >
        <div id='bo_share__main-button' className='bo_share__main-button' onClick={this.handleMainButtonClick}>
          <CSSTransitionGroup
            transitionName='bo_share'
            transitionEnterTimeout={750}
            transitionLeaveTimeout={750}
          >
            {(this.state.isEnabled)
              ? <div className='bo_share__main-button-icon-close' style={{ backgroundImage: `url(${closeIcon})` }} key={0} />
              : <div className='bo_share__main-button-icon-share' style={{ backgroundImage: `url(${shareIcon})` }} key={1} />
            }
          </CSSTransitionGroup>
        </div>

        {/*{this.state.isEnabled &&*/}
        {/**/}
        {/*}*/}
        <div className={`bo_share bo_share__bg ${this.state.isEnabled ? 'bo_share__in' : 'bo_share__out'}`} key='share'>
          <div id='bo_share__title' className='bo_share__title'>
            <span className='bo_share__title--text'>{shareSubtitle}</span>
          </div>
          <div id='bo_share__subtitle' className='bo_share__subtitle'>
            <span className='bo_share__subtitle--text'>{shareTitle}</span>
          </div>
          <div className='bo_share__buttons'>
            <div id='bo_share__button--facebook' className='bo_share__button bo_share__button--facebook' onClick={() => this.goToUrl(facebook)}>
              <div className='bo_share__button-icon' style={{ backgroundImage: `url(${facebookIcon})` }} />
            </div>
            <div id='bo_share__button--twitter' className='bo_share__button bo_share__button--twitter' onClick={() => this.goToUrl(twitter)}>
              <div className='bo_share__button-icon' style={{ backgroundImage: `url(${twitterIcon})` }} />
            </div>
            <div id='bo_share__button--email' className='bo_share__button bo_share__button--email' onClick={() => this.goToUrl(`mailto:${email}`)}>
              <div className='bo_share__button-icon' style={{ backgroundImage: `url(${emailIcon})` }} />
            </div>
            <div id='bo_share__button--sms' className='bo_share__button bo_share__button--sms' onClick={() => this.goToUrl(`sms:${phone}`)}>
              <div className='bo_share__button-icon' style={{ backgroundImage: `url(${smsIcon})` }} />
            </div>
          </div>
        </div>
      </CSSTransitionGroup>
    )
  }

  static propTypes = {
    facebook: PropTypes.string,
    twitter: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    shareTitle: PropTypes.string,
    shareSubtitle: PropTypes.string,
    setShareButtonsVisible: PropTypes.func
  }
}



// WEBPACK FOOTER //
// ./src/templates/bouncy/components/last/ShareButton.js